import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import './index.css';

import { PageName } from 'client/bundles/types';

const b = cn('stocks');
const bPageTitle = cn('page-title');

interface Props {
    title: string;
    pageName: PageName;
    stocksUrl: string;
    text: string;
    isShowIframe: boolean;
}

class Stocks extends Component<Props> {
    static contextType = LangContext;

    onIframeLoad = (e: React.SyntheticEvent<HTMLIFrameElement, Event>) => {
        if (window.iFrameResize) {
            window.iFrameResize({}, e.target);
        }
    }

    render() {
        const { stocksUrl, title, text, isShowIframe } = this.props;

        return (
            <div className={b()}>
                <h1 className={bPageTitle({ type: 'border' })}>{title}</h1>

                {
                    text &&
                        <p className={b('text')}>
                            {text}
                        </p>
                }

                {
                    isShowIframe &&
                        <iframe
                            className={b('stock-iframe')}
                            src={stocksUrl}
                            onLoad={this.onIframeLoad}
                            frameBorder="no"
                            scrolling="no"
                            />
                }
            </div>
        );
    }
}

export default Stocks;
